/**
 * Web Vitals RUM Boot
 *
 * Registers the Core Web Vitals field collector (§P1-D). Runs on web and
 * Capacitor WebView alike — the WebView users are exactly the ones CrUX can't
 * see, so they are the point of shipping our own RUM.
 *
 * Non-blocking and inert by default: `reportWebVitals()` returns immediately
 * unless `VITE_RUM_ENDPOINT` is set, and the `web-vitals` module is lazy-loaded
 * so it never sits on the boot critical path. The route is scrubbed to a
 * template before any metric leaves the client (privacy note in webVitals.ts).
 */
import { defineBoot } from '#q-app';
import { reportWebVitals } from 'src/utils/webVitals';

export default defineBoot(() => {
  reportWebVitals();
});
